import React, { useState } from 'react';
import { TruckIcon, ClipboardIcon, MessageCircleIcon, BellIcon, ChevronDownIcon, PlusIcon, CalendarIcon, FileTextIcon, ArrowUpCircleIcon, ArrowDownCircleIcon, CheckCircleIcon, XCircleIcon, MenuIcon, BuildingIcon, HandshakeIcon } from 'lucide-react';
import { MessageNotifications } from '../../messaging/MessageNotifications';
import { MessageCenter } from '../../messaging/MessageCenter';
import { JobMessagingNotification } from '../../messaging/JobMessagingNotification';
import { JobMessageButton } from '../../messaging/JobMessageButton';
import { RequestMaterialsModal } from './RequestMaterialsModal';
export const ForemanDashboard = () => {
  const [activeTab, setActiveTab] = useState('current');
  const [showMessageCenter, setShowMessageCenter] = useState(false);
  const [currentJobId, setCurrentJobId] = useState('job-1'); // Default to first job
  const [showRequestMaterialsModal, setShowRequestMaterialsModal] = useState(false);
  const [materialRequests, setMaterialRequests] = useState<any[]>([]);
  const [showRequestsHistory, setShowRequestsHistory] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showMessageMenu, setShowMessageMenu] = useState(false);
  // Current job details - in a real app, these would come from a database
  const currentJob = {
    name: 'Downtown SLC Project',
    number: 'JOB-2023-001',
    location: '123 Main St, Salt Lake City',
    foreman: 'John Smith'
  };
  const handleRequestMaterials = (requestData: any) => {
    // Add the new request to the materialRequests array
    setMaterialRequests([...materialRequests, requestData]);
    setShowRequestMaterialsModal(false);
    // Show success notification
    alert('Material request submitted successfully! The contractor will review your request.');
  };
  const getUrgencyColor = (urgency: string) => {
    switch (urgency) {
      case 'high':
        return 'text-red-600 bg-red-100';
      case 'medium':
        return 'text-yellow-600 bg-yellow-100';
      case 'low':
        return 'text-green-600 bg-green-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'approved':
        return 'text-green-600 bg-green-100';
      case 'declined':
        return 'text-red-600 bg-red-100';
      case 'pending':
        return 'text-yellow-600 bg-yellow-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };
  return <div className="p-4 w-full bg-gray-50 min-h-screen" data-id="element-3303">
      {/* Mobile Header */}
      <div className="flex justify-between items-center mb-4 sticky top-0 bg-white p-3 shadow-sm rounded-lg z-10" data-id="element-3304">
        <div className="w-10" data-id="element-3305">{/* Empty div for spacing */}</div>
        <h1 className="text-xl font-bold text-center text-[#0F2A52]" data-id="element-3306">
          Foreman Dashboard
        </h1>
        <div className="flex items-center gap-2" data-id="element-3307">
          <JobMessagingNotification jobId={currentJobId} data-id="element-3308" />
          <button onClick={() => setShowMessageMenu(!showMessageMenu)} className="p-2 bg-[#F58220]/20 text-[#F58220] rounded-full relative" data-id="element-3309">
            <MessageCircleIcon size={20} data-id="element-3310" />
          </button>
          <button onClick={() => setShowMobileMenu(!showMobileMenu)} className="p-2 bg-gray-100 rounded-full" data-id="element-3311">
            <MenuIcon size={20} data-id="element-3312" />
          </button>
        </div>
      </div>
      {/* Mobile Quick Messaging Menu */}
      {showMessageMenu && <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowMessageMenu(false)} data-id="element-3313">
          <div className="absolute top-16 right-4 bg-white rounded-lg shadow-xl p-3 w-64" onClick={e => e.stopPropagation()} data-id="element-3314">
            <h3 className="text-sm font-medium mb-2 text-gray-700" data-id="element-3315">Message</h3>
            <div className="space-y-2" data-id="element-3316">
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="driver" buttonText="Message Drivers" className="w-full flex items-center gap-2 p-2 rounded-md bg-[#0F2A52]/10 text-[#0F2A52] hover:bg-[#0F2A52]/20" data-id="element-3317">
                <TruckIcon size={18} data-id="element-3318" />
                <span data-id="element-3319">Message Drivers</span>
              </JobMessageButton>
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="broker" buttonText="Message Broker" className="w-full flex items-center gap-2 p-2 rounded-md bg-[#F58220]/10 text-[#F58220] hover:bg-[#F58220]/20" data-id="element-3320">
                <HandshakeIcon size={18} data-id="element-3321" />
                <span data-id="element-3322">Message Broker</span>
              </JobMessageButton>
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="contractor" buttonText="Message Contractor" className="w-full flex items-center gap-2 p-2 rounded-md bg-[#0F2A52]/10 text-[#0F2A52] hover:bg-[#0F2A52]/20" data-id="element-3323">
                <BuildingIcon size={18} data-id="element-3324" />
                <span data-id="element-3325">Message Contractor</span>
              </JobMessageButton>
            </div>
          </div>
        </div>}
      {/* Mobile Quick Actions Menu */}
      {showMobileMenu && <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setShowMobileMenu(false)} data-id="element-3326">
          <div className="absolute bottom-0 left-0 right-0 bg-white rounded-t-xl p-4" onClick={e => e.stopPropagation()} data-id="element-3327">
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4" data-id="element-3328"></div>
            <h3 className="text-lg font-medium mb-3 text-[#0F2A52]" data-id="element-3329">
              Quick Actions
            </h3>
            <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-3330">
              <button className="flex flex-col items-center justify-center bg-[#0F2A52]/10 p-4 rounded-lg border border-[#0F2A52]/20" onClick={() => {
            setShowRequestMaterialsModal(true);
            setShowMobileMenu(false);
          }} data-id="element-3331">
                <TruckIcon size={24} className="text-[#0F2A52] mb-2" data-id="element-3332" />
                <span className="text-sm font-medium" data-id="element-3333">Request Materials</span>
              </button>
              <button className="flex flex-col items-center justify-center bg-[#F58220]/10 p-4 rounded-lg border border-[#F58220]/20" data-id="element-3334">
                <ClipboardIcon size={24} className="text-[#F58220] mb-2" data-id="element-3335" />
                <span className="text-sm font-medium" data-id="element-3336">Update Progress</span>
              </button>
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="driver" buttonText="Message Drivers" className="flex flex-col items-center justify-center bg-[#0F2A52]/10 p-4 rounded-lg border border-[#0F2A52]/20" showIcon={true} data-id="element-3337">
                <MessageCircleIcon size={24} className="text-[#0F2A52] mb-2" data-id="element-3338" />
                <span className="text-sm font-medium" data-id="element-3339">Message Drivers</span>
              </JobMessageButton>
              <button className="flex flex-col items-center justify-center bg-[#F58220]/10 p-4 rounded-lg border border-[#F58220]/20" onClick={() => setShowMobileMenu(false)} data-id="element-3340">
                <CalendarIcon size={24} className="text-[#F58220] mb-2" data-id="element-3341" />
                <span className="text-sm font-medium" data-id="element-3342">View Schedule</span>
              </button>
            </div>
            <button className="w-full py-3 bg-gray-200 rounded-lg font-medium" onClick={() => setShowMobileMenu(false)} data-id="element-3343">
              Close
            </button>
          </div>
        </div>}
      {/* Tabs - Scrollable on Mobile */}
      <div className="flex border-b mb-4 overflow-x-auto pb-1 -mx-1 px-1" data-id="element-3344">
        <button className={`px-4 py-2 font-medium whitespace-nowrap ${activeTab === 'current' ? 'text-[#0F2A52] border-b-2 border-[#F58220]' : 'text-gray-500'}`} onClick={() => setActiveTab('current')} data-id="element-3345">
          Current Jobs
        </button>
        <button className={`px-4 py-2 font-medium whitespace-nowrap ${activeTab === 'upcoming' ? 'text-[#0F2A52] border-b-2 border-[#F58220]' : 'text-gray-500'}`} onClick={() => setActiveTab('upcoming')} data-id="element-3346">
          Upcoming Jobs
        </button>
        <button className={`px-4 py-2 font-medium whitespace-nowrap ${activeTab === 'completed' ? 'text-[#0F2A52] border-b-2 border-[#F58220]' : 'text-gray-500'}`} onClick={() => setActiveTab('completed')} data-id="element-3347">
          <div className="flex items-center gap-1" data-id="element-3348">
            <FileTextIcon size={16} data-id="element-3349" />
            Completed
          </div>
        </button>
      </div>
      {activeTab === 'current' && <>
          {/* Active Job */}
          <div className="bg-white rounded-lg shadow-md p-4 mb-4" data-id="element-3350">
            <div className="flex justify-between items-center mb-3" data-id="element-3351">
              <h2 className="text-lg font-bold text-[#0F2A52]" data-id="element-3352">
                Downtown SLC Project
              </h2>
              <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-3353">
                Active
              </span>
            </div>
            <div className="grid grid-cols-1 gap-3 mb-4" data-id="element-3354">
              <div className="bg-gray-50 p-3 rounded-md" data-id="element-3355">
                <div className="text-xs text-gray-500 mb-0.5" data-id="element-3356">Job Number</div>
                <div className="font-medium" data-id="element-3357">JOB-2023-001</div>
              </div>
              <div className="bg-gray-50 p-3 rounded-md" data-id="element-3358">
                <div className="text-xs text-gray-500 mb-0.5" data-id="element-3359">Location</div>
                <div className="font-medium" data-id="element-3360">123 Main St, Salt Lake City</div>
              </div>
              <div className="bg-gray-50 p-3 rounded-md" data-id="element-3361">
                <div className="text-xs text-gray-500 mb-0.5" data-id="element-3362">Contractor</div>
                <div className="font-medium" data-id="element-3363">John Contractor</div>
              </div>
            </div>
            {/* Communication Buttons */}
            <div className="flex flex-wrap gap-2 mb-4" data-id="element-3364">
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="driver" buttonText="Message Drivers" className="flex items-center gap-1 bg-[#0F2A52]/10 text-[#0F2A52] px-3 py-1.5 rounded-md text-sm" data-id="element-3365">
                <TruckIcon size={14} data-id="element-3366" />
                <span data-id="element-3367">Drivers</span>
              </JobMessageButton>
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="broker" buttonText="Message Broker" className="flex items-center gap-1 bg-[#F58220]/10 text-[#F58220] px-3 py-1.5 rounded-md text-sm" data-id="element-3368">
                <HandshakeIcon size={14} data-id="element-3369" />
                <span data-id="element-3370">Broker</span>
              </JobMessageButton>
              <JobMessageButton jobId={currentJobId} jobName="Downtown SLC Project" recipientRole="contractor" buttonText="Message Contractor" className="flex items-center gap-1 bg-[#0F2A52]/10 text-[#0F2A52] px-3 py-1.5 rounded-md text-sm" data-id="element-3371">
                <BuildingIcon size={14} data-id="element-3372" />
                <span data-id="element-3373">Contractor</span>
              </JobMessageButton>
            </div>
            <h3 className="font-medium text-base mb-2 text-[#0F2A52]" data-id="element-3374">
              Material Progress
            </h3>
            <div className="space-y-3 mb-4" data-id="element-3375">
              <div data-id="element-3376">
                <div className="flex justify-between mb-1" data-id="element-3377">
                  <span className="text-sm font-medium" data-id="element-3378">Road Base</span>
                  <span className="text-sm text-gray-500" data-id="element-3379">210/300 tons</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-3380">
                  <div className="bg-[#0F2A52] h-2.5 rounded-full" style={{
                width: '70%'
              }} data-id="element-3381"></div>
                </div>
              </div>
              <div data-id="element-3382">
                <div className="flex justify-between mb-1" data-id="element-3383">
                  <span className="text-sm font-medium" data-id="element-3384">Gravel</span>
                  <span className="text-sm text-gray-500" data-id="element-3385">45/50 tons</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-3386">
                  <div className="bg-[#0F2A52] h-2.5 rounded-full" style={{
                width: '90%'
              }} data-id="element-3387"></div>
                </div>
              </div>
              <div data-id="element-3388">
                <div className="flex justify-between mb-1" data-id="element-3389">
                  <span className="text-sm font-medium" data-id="element-3390">Sand</span>
                  <span className="text-sm text-gray-500" data-id="element-3391">25/75 tons</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-3392">
                  <div className="bg-[#0F2A52] h-2.5 rounded-full" style={{
                width: '33%'
              }} data-id="element-3393"></div>
                </div>
              </div>
            </div>
            <h3 className="font-medium text-base mb-2 text-[#0F2A52]" data-id="element-3394">
              Recent Activity
            </h3>
            <div className="space-y-2 mb-4" data-id="element-3395">
              <div className="flex items-start gap-2 p-2 bg-gray-50 rounded-md" data-id="element-3396">
                <ArrowUpCircleIcon size={18} className="text-[#F58220] mt-0.5 flex-shrink-0" data-id="element-3397" />
                <div data-id="element-3398">
                  <div className="font-medium text-sm" data-id="element-3399">
                    Truck #103 delivered 25 tons of Road Base
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-3400">Today, 10:25 AM</div>
                </div>
              </div>
              <div className="flex items-start gap-2 p-2 bg-gray-50 rounded-md" data-id="element-3401">
                <ArrowUpCircleIcon size={18} className="text-[#F58220] mt-0.5 flex-shrink-0" data-id="element-3402" />
                <div data-id="element-3403">
                  <div className="font-medium text-sm" data-id="element-3404">
                    Truck #87 delivered 15 tons of Gravel
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-3405">Today, 9:15 AM</div>
                </div>
              </div>
            </div>
            {/* Mobile-friendly action buttons */}
            <div className="grid grid-cols-2 gap-2" data-id="element-3406">
              <button className="flex items-center justify-center gap-1 bg-[#0F2A52] hover:bg-[#0F2A52]/90 text-white px-3 py-2.5 rounded-md text-sm font-medium" onClick={() => setShowRequestMaterialsModal(true)} data-id="element-3407">
                <TruckIcon size={16} data-id="element-3408" />
                Request Materials
              </button>
            </div>
            {/* Material Requests History */}
            {materialRequests.length > 0 && <div className="mt-4 pt-4 border-t" data-id="element-3409">
                <div className="flex justify-between items-center mb-2" data-id="element-3410">
                  <h3 className="font-medium text-base text-[#0F2A52]" data-id="element-3411">
                    Material Requests
                  </h3>
                  <button className="text-[#F58220] text-xs font-medium" onClick={() => setShowRequestsHistory(!showRequestsHistory)} data-id="element-3412">
                    {showRequestsHistory ? 'Hide' : 'Show'}
                  </button>
                </div>
                {showRequestsHistory && <div className="bg-gray-50 rounded-md p-3 space-y-2" data-id="element-3413">
                    {materialRequests.map((request, index) => <div key={index} className="border rounded-md p-2 bg-white" data-id="element-3414">
                        <div className="flex justify-between items-center mb-1" data-id="element-3415">
                          <div className="flex items-center gap-1" data-id="element-3416">
                            <TruckIcon size={14} className="text-gray-500" data-id="element-3417" />
                            <span className="font-medium text-sm" data-id="element-3418">
                              {request.material}
                            </span>
                            <span className={`px-1.5 py-0.5 rounded-full text-xs font-medium ${getUrgencyColor(request.urgency)}`} data-id="element-3419">
                              {request.urgency.toUpperCase()}
                            </span>
                          </div>
                          <span className={`px-1.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(request.status)}`} data-id="element-3420">
                            {request.status.toUpperCase()}
                          </span>
                        </div>
                        <div className="text-xs mb-1" data-id="element-3421">
                          {request.requestType === 'trucks' && `${request.trucksRequested} trucks`}
                          {request.requestType === 'tonnage' && `${request.tonnageRequested} tons`}
                          {request.requestType === 'both' && `${request.trucksRequested} trucks, ${request.tonnageRequested} tons`}
                          {` of ${request.material} (${request.truckType})`}
                        </div>
                        <div className="text-xs text-gray-500" data-id="element-3422">
                          For {request.requestedDate} at {request.requestTime}
                        </div>
                      </div>)}
                  </div>}
              </div>}
          </div>
          {/* Other Assigned Jobs */}
          <h3 className="font-medium text-base mb-2 text-[#0F2A52]" data-id="element-3423">
            Other Assigned Jobs
          </h3>
          <div className="bg-white rounded-lg shadow-md divide-y" data-id="element-3424">
            <div className="p-3 hover:bg-gray-50 active:bg-gray-100" data-id="element-3425">
              <div className="flex justify-between items-center" data-id="element-3426">
                <h4 className="font-medium" data-id="element-3427">Sugar House Development</h4>
                <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3428">
                  Tomorrow
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3429">
                JOB-2023-002 • 2100 S 1100 E, Salt Lake City
              </div>
              <div className="flex justify-between items-center mt-2" data-id="element-3430">
                <div className="text-xs" data-id="element-3431">
                  <span className="font-medium" data-id="element-3432">Materials:</span> 150 tons Road
                  Base
                </div>
                <button className="text-[#F58220] hover:text-[#F58220]/80 text-xs font-medium" data-id="element-3433">
                  View
                </button>
              </div>
            </div>
            <div className="p-3 hover:bg-gray-50 active:bg-gray-100" data-id="element-3434">
              <div className="flex justify-between items-center" data-id="element-3435">
                <h4 className="font-medium" data-id="element-3436">West Valley Materials Yard</h4>
                <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3437">
                  Next Week
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3438">
                JOB-2023-003 • 3500 W 4500 S, West Valley City
              </div>
              <div className="flex justify-between items-center mt-2" data-id="element-3439">
                <div className="text-xs" data-id="element-3440">
                  <span className="font-medium" data-id="element-3441">Materials:</span> 200 tons Road
                  Base
                </div>
                <button className="text-[#F58220] hover:text-[#F58220]/80 text-xs font-medium" data-id="element-3442">
                  View
                </button>
              </div>
            </div>
          </div>
        </>}
      {activeTab === 'upcoming' && <div className="bg-white rounded-lg shadow-md p-4" data-id="element-3443">
          <div className="flex items-center justify-between mb-3" data-id="element-3444">
            <h3 className="font-medium text-base text-[#0F2A52]" data-id="element-3445">
              Upcoming Jobs
            </h3>
            <div className="flex items-center gap-1" data-id="element-3446">
              <CalendarIcon size={14} className="text-gray-500" data-id="element-3447" />
              <span className="text-xs text-gray-500" data-id="element-3448">Next 7 Days</span>
            </div>
          </div>
          <div className="space-y-3" data-id="element-3449">
            <div className="border rounded-md p-3" data-id="element-3450">
              <div className="flex justify-between items-center" data-id="element-3451">
                <h4 className="font-medium" data-id="element-3452">Sugar House Development</h4>
                <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3453">
                  Tomorrow
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3454">
                JOB-2023-002 • 2100 S 1100 E, Salt Lake City
              </div>
              <div className="grid grid-cols-1 gap-2 mt-2" data-id="element-3455">
                <div data-id="element-3456">
                  <div className="text-xs text-gray-500" data-id="element-3457">Materials Needed</div>
                  <div className="text-xs" data-id="element-3458">
                    150 tons Road Base, 25 tons Gravel
                  </div>
                </div>
                <div data-id="element-3459">
                  <div className="text-xs text-gray-500" data-id="element-3460">Scheduled Trucks</div>
                  <div className="text-xs" data-id="element-3461">5 Double Belly Trucks</div>
                </div>
              </div>
              <div className="mt-2 flex gap-2" data-id="element-3462">
                <button className="text-[#0F2A52] hover:text-[#0F2A52]/80 text-xs font-medium" data-id="element-3463">
                  View Details
                </button>
                <button className="text-[#F58220] hover:text-[#F58220]/80 text-xs font-medium" data-id="element-3464">
                  Prepare Site
                </button>
              </div>
            </div>
            <div className="border rounded-md p-3" data-id="element-3465">
              <div className="flex justify-between items-center" data-id="element-3466">
                <h4 className="font-medium" data-id="element-3467">West Valley Materials Yard</h4>
                <span className="bg-gray-100 text-gray-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3468">
                  Monday
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3469">
                JOB-2023-003 • 3500 W 4500 S, West Valley City
              </div>
              <div className="grid grid-cols-1 gap-2 mt-2" data-id="element-3470">
                <div data-id="element-3471">
                  <div className="text-xs text-gray-500" data-id="element-3472">Materials Needed</div>
                  <div className="text-xs" data-id="element-3473">
                    200 tons Road Base, 100 tons Sand
                  </div>
                </div>
                <div data-id="element-3474">
                  <div className="text-xs text-gray-500" data-id="element-3475">Scheduled Trucks</div>
                  <div className="text-xs" data-id="element-3476">8 Double Belly Trucks</div>
                </div>
              </div>
              <div className="mt-2 flex gap-2" data-id="element-3477">
                <button className="text-[#0F2A52] hover:text-[#0F2A52]/80 text-xs font-medium" data-id="element-3478">
                  View Details
                </button>
                <button className="text-[#F58220] hover:text-[#F58220]/80 text-xs font-medium" data-id="element-3479">
                  Prepare Site
                </button>
              </div>
            </div>
          </div>
        </div>}
      {activeTab === 'completed' && <div className="bg-white rounded-lg shadow-md p-4" data-id="element-3480">
          <div className="flex items-center justify-between mb-3" data-id="element-3481">
            <h3 className="font-medium text-base text-[#0F2A52]" data-id="element-3482">
              Completed Jobs
            </h3>
            <button className="text-xs text-[#F58220] flex items-center gap-1" data-id="element-3483">
              <FileTextIcon size={14} data-id="element-3484" />
              Export
            </button>
          </div>
          <div className="space-y-3" data-id="element-3485">
            <div className="border rounded-md p-3" data-id="element-3486">
              <div className="flex justify-between items-center" data-id="element-3487">
                <h4 className="font-medium" data-id="element-3488">North Quarry Excavation</h4>
                <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3489">
                  Aug 10
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3490">
                JOB-2023-004 • North Quarry Site
              </div>
              <div className="grid grid-cols-1 gap-1 mt-2" data-id="element-3491">
                <div data-id="element-3492">
                  <div className="text-xs text-gray-500" data-id="element-3493">Total Materials</div>
                  <div className="text-xs" data-id="element-3494">
                    350 tons Road Base, 75 tons Gravel
                  </div>
                </div>
                <div data-id="element-3495">
                  <div className="text-xs text-gray-500" data-id="element-3496">Total Trucks</div>
                  <div className="text-xs" data-id="element-3497">15 Loads</div>
                </div>
                <div data-id="element-3498">
                  <div className="text-xs text-gray-500" data-id="element-3499">Completion Time</div>
                  <div className="text-xs" data-id="element-3500">2 days (ahead of schedule)</div>
                </div>
              </div>
              <div className="mt-2" data-id="element-3501">
                <button className="text-[#0F2A52] hover:text-[#0F2A52]/80 text-xs font-medium" data-id="element-3502">
                  View Report
                </button>
              </div>
            </div>
            <div className="border rounded-md p-3" data-id="element-3503">
              <div className="flex justify-between items-center" data-id="element-3504">
                <h4 className="font-medium" data-id="element-3505">East Canyon Excavation</h4>
                <span className="bg-green-100 text-green-800 text-xs font-medium px-2 py-0.5 rounded-full" data-id="element-3506">
                  Jul 28
                </span>
              </div>
              <div className="text-xs text-gray-500 mt-1" data-id="element-3507">
                JOB-2023-005 • East Canyon Site
              </div>
              <div className="grid grid-cols-1 gap-1 mt-2" data-id="element-3508">
                <div data-id="element-3509">
                  <div className="text-xs text-gray-500" data-id="element-3510">Total Materials</div>
                  <div className="text-xs" data-id="element-3511">
                    275 tons Road Base, 50 tons Sand
                  </div>
                </div>
                <div data-id="element-3512">
                  <div className="text-xs text-gray-500" data-id="element-3513">Total Trucks</div>
                  <div className="text-xs" data-id="element-3514">12 Loads</div>
                </div>
                <div data-id="element-3515">
                  <div className="text-xs text-gray-500" data-id="element-3516">Completion Time</div>
                  <div className="text-xs" data-id="element-3517">3 days (on schedule)</div>
                </div>
              </div>
              <div className="mt-2" data-id="element-3518">
                <button className="text-[#0F2A52] hover:text-[#0F2A52]/80 text-xs font-medium" data-id="element-3519">
                  View Report
                </button>
              </div>
            </div>
          </div>
        </div>}
      {/* Fixed Action Button for Mobile */}
      <div className="fixed bottom-4 right-4 z-20" data-id="element-3520">
        <button className="bg-[#0F2A52] text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center" onClick={() => setShowRequestMaterialsModal(true)} data-id="element-3521">
          <PlusIcon size={24} data-id="element-3522" />
        </button>
      </div>
      {showMessageCenter && <MessageCenter onClose={() => setShowMessageCenter(false)} data-id="element-3523" />}
      {/* Request Materials Modal */}
      <RequestMaterialsModal isOpen={showRequestMaterialsModal} onClose={() => setShowRequestMaterialsModal(false)} onSubmit={handleRequestMaterials} jobName={currentJob.name} jobNumber={currentJob.number} currentLocation={currentJob.location} foremanName={currentJob.foreman} data-id="element-3524" />
    </div>;
};